import { connect } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import {
  fetchingSelector,
  fundedPositionsSelector,
} from '@alphapoint/apex-web/lib/redux/selectors/productPositionSelectors';
import { showSnack } from '@alphapoint/apex-web/lib/redux/actions/snackbarActions';
import { instrumentsWithProductFullNamesAndProductSymbols } from '@alphapoint/apex-web/lib/redux/selectors/instrumentPositionSelectors';
import {
  getLevel1Data,
  subscribeToLevel1,
  unsubscribeLevel1,
} from '@alphapoint/apex-web/lib/redux/actions/level1Actions';
import { subscribeToLevel2 } from '@alphapoint/apex-web/lib/redux/actions/level2Actions';
import { setInstrument } from '@alphapoint/apex-web/lib/redux/actions/instrumentActions';
import StreamingCardGridComponent from './StreamingCardGridComponent';
import filterSortSupportedInstruments from '@alphapoint/apex-web/lib/helpers/filterSortSupportedInstruments';
import config from '@alphapoint/apex-web/lib/config';
import { selectInstrumentsProduct2Options } from '../../redux/instrumentsSelector';

const streamingForm = 'StreamingForm';
const { StreamingInstruments } = config;

const filterInstruments = (allInstruments) => {
  const standardInstruments = filterSortSupportedInstruments(allInstruments);

  const displaySymbols = StreamingInstruments.Symbol;
  if (displaySymbols.length) {
    return standardInstruments.filter((i) => {
      return displaySymbols.includes(i.Symbol);
    });
  }

  return standardInstruments;
};

const mapStateToProps = (state) => {
  return {
    fetching: fetchingSelector(state),
    state: state,
    products: fundedPositionsSelector(state),
    instruments: filterInstruments(instrumentsWithProductFullNamesAndProductSymbols(state)),
    level1: state.apexCore.level1,
    productManifest: state.productManifest,
    formData: state.form[streamingForm],
    AccountId: state.user.selectedAccountId,
    selectedInstrumentId: state.apexCore.instrument.selectedInstrumentId,
    additionalSlipage: StreamingInstruments.additionalSlippage,
    product2Options: selectInstrumentsProduct2Options(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInstrument: (payload) => {
      dispatch(setInstrument(payload.instrumentId));
      localStorage.setItem('selectedInstrumentId', payload.instrumentId);
      // resubscribe to level2
      dispatch(subscribeToLevel1(payload.instrumentId));
      dispatch(subscribeToLevel2(payload.instrumentId));
    },
    getLevel1Data: (InstrumentId) => dispatch(getLevel1Data(InstrumentId)),
    unsubscribeLevel1: (InstrumentId) => dispatch(unsubscribeLevel1(InstrumentId)),
    subscribeToLevel1: (InstrumentId) => dispatch(subscribeToLevel1(InstrumentId)),
    changeReduxForm: (payload) => dispatch(change(streamingForm, payload.field, payload.value)),
    showNotification: (message) => {
      dispatch(
        showSnack({
          id: 'validationNotification',
          text: message,
          type: 'warning',
        }),
      );
    },
  };
};

const StreamingCardGridContainer = connect(mapStateToProps, mapDispatchToProps)(StreamingCardGridComponent);

export default reduxForm({
  form: streamingForm,
  enableReinitialize: true,
})(StreamingCardGridContainer);
